import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-subjects',
  templateUrl: './subjects.component.html',
  styleUrls: ['./subjects.component.css']
})
export class SubjectsComponent extends BaseCrudComponent {

    translations: any;
    listUsers: any;
    listDocs: any;
    listPerms: any;
    loadingRequired: any;
    branches: any;

    listZones: any;
    listChiefs: any;
    listSupervisor: any;
    listAgents: any;

    listAgentsBackup: any;
    
    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'SalesGeneralInformation/Subject/All';
        this.create_url = 'SalesGeneralInformation/Subject/Create';
        this.update_url = 'SalesGeneralInformation/Subject/Update';
        this.delete_url = 'SalesGeneralInformation/Subject/LogicalDelete';
        this.search_fields = ['name', 'description'];
        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
            });
    }

    public getFiltersData() {
        var par_url = 'Profile/All';

        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    openCreateModal(content: any) {
        this.c_obj = {};
        super.openCreateModal(content);
    }

    openUpdateModal(content: any, obj: any) {
        super.openUpdateModal(content, obj);
    }

    validateCreateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required])
        });

        return mygroup.valid;
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required])
        });

        return mygroup.valid;
    }

    public createItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }
        //console.log(form);
        validated = this.validateCreateInfo(form);
      

        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        //to = {};
        to = form;
        
        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if (x.status) {
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations.created, '', 'success');
            }//end success
            else {
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        // to = {};
        // to.id = form.id;
        to = form;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'error');
                //this.closeModal(content);
            }
        });
    }

    searchUsers = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.listUsers.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
        );

    formatterUsers = (x: any) => x.name;

}
